import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { GetCustomerItemLedgerApi } from "../../ApiRequests";

export const fetchItemLedger = createAsyncThunk(
  "fetch/ItemLedger",
  async (id) => {
    try {
      let response = await GetCustomerItemLedgerApi(id);
      return [
        {
          invoice: "55",
          name: "3 qat RS big Nasir",
          qty: 20,
          price: 84,
          date: 1744761600,
          cr: 1680,
          dr: 0,
          balance: 1680,
        },
        {
          invoice: "88",
          name: "3 qat RS big Nasir",
          qty: 30,
          price: 84,
          date: 1744761600,
          cr: 2520,
          dr: 0,
          balance: 4200,
        },
        {
          invoice: "88",
          name: "Mix Fruit 20 Nasir",
          qty: 30,
          price: 74,
          date: 1744761600,
          cr: 2220,
          dr: 0,
          balance: 6420,
        },
        {
          invoice: "1234",
          name: "Test 427 Test",
          qty: 10,
          price: 425,
          date: 1744675200,
          cr: 4250,
          dr: 0,
          balance: 10670,
        },
        {
          invoice: "1234563",
          name: "Test 427 Test",
          qty: 10,
          price: 425,
          date: 1744675200,
          cr: 4250,
          dr: 0,
          balance: 14920,
        },
        {
          invoice: "765432",
          name: "test12 test",
          qty: 100,
          price: 15,
          date: 1744675200,
          cr: 1500,
          dr: 0,
          balance: 16420,
        },
        {
          invoice: "7654321",
          name: "3 qat RS big Nasir",
          qty: 100,
          price: 84,
          date: 1744675200,
          cr: 8400,
          dr: 0,
          balance: 24820,
        },
        {
          invoice: "7654321",
          name: "Test 427 Test",
          qty: 10,
          price: 425,
          date: 1744675200,
          cr: 4250,
          dr: 0,
          balance: 29070,
        },
        {
          invoice: "7654321",
          name: "2 qat RS 20 Nasir",
          qty: 100,
          price: 76,
          date: 1744675200,
          cr: 7600,
          dr: 0,
          balance: 36670,
        },
        {
          invoice: "876543",
          name: "3 qat RS big Nasir",
          qty: 100,
          price: 84,
          date: 1744675200,
          cr: 8400,
          dr: 0,
          balance: 45070,
        },
        {
          invoice: "876543",
          name: "Test 427 Test",
          qty: 10,
          price: 425,
          date: 1744675200,
          cr: 4250,
          dr: 0,
          balance: 49320,
        },
        {
          invoice: "876543",
          name: "2 qat RS 20 Nasir",
          qty: 100,
          price: 76,
          date: 1744675200,
          cr: 7600,
          dr: 0,
          balance: 56920,
        },
        {
          invoice: "8765425",
          name: "3 qat RS big Nasir",
          qty: 100,
          price: 84,
          date: 1744675200,
          cr: 8400,
          dr: 0,
          balance: 65320,
        },
        {
          invoice: "8765425",
          name: "Test 427 Test",
          qty: 10,
          price: 425,
          date: 1744675200,
          cr: 4250,
          dr: 0,
          balance: 69570,
        },
        {
          invoice: "8765425",
          name: "2 qat RS 20 Nasir",
          qty: 100,
          price: 76,
          date: 1744675200,
          cr: 7600,
          dr: 0,
          balance: 77170,
        },
      ];
    } catch (error) {
      console.log(error);
    }
    return [];
  }
);

const ItemLedgerSlice = createSlice({
  name: "ItemLedger",
  initialState: {
    loading: false,
    data: [],
    isError: false,
  },
  extraReducers: (builder) => {
    builder.addCase(fetchItemLedger.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(fetchItemLedger.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload;
      state.isError = false;
    });
    builder.addCase(fetchItemLedger.rejected, (state, action) => {
      state.loading = false;
      state.isError = true;
    });
  },
});

export default ItemLedgerSlice.reducer;
